import { render, staticRenderFns } from "./AlertIndicator.vue?vue&type=template&id=2fffb3c6&scoped=true&"
import script from "./AlertIndicator.vue?vue&type=script&lang=js&"
export * from "./AlertIndicator.vue?vue&type=script&lang=js&"
import style0 from "./AlertIndicator.vue?vue&type=style&index=0&id=2fffb3c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fffb3c6",
  null
  
)

export default component.exports